import styled from 'styled-components';

export const Conatiner = styled.div`
  font-size: rgba(0, 0, 255);
  h1 .all {
    background: green;
  }
`;
